module.exports = __webpack_public_path__ + "media/images/banner_osm_mobile-fb00be0ceb2a527aa1b14911efdb0ec6.png";